import { useState, useCallback } from "react";

export const ALL_QUICK_ACTIONS = [
  "feeding",
  "sleep",
  "tummyTime",
  "diaper",
  "extractedMilk",
  "medicine",
];

const STORAGE_KEY = "quickActionPrefs";

export default function useQuickActionPrefs() {
  const [visibleActions, setVisibleActions] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : ALL_QUICK_ACTIONS;
    } catch {
      return ALL_QUICK_ACTIONS;
    }
  });

  const toggleAction = useCallback((key) => {
    setVisibleActions((prev) => {
      const next = prev.includes(key)
        ? prev.filter((k) => k !== key)
        : [...prev, key];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  return { visibleActions, toggleAction };
}
